/**
 * Wraps company routes. Runs UTM bootstrap in useLayoutEffect (before child componentDidMount)
 * so UTMs are in Redux before any flow creates a search.
 */
import { useLayoutEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ACTIONS from '../redux/action';
import { dispatchUtmParams, parseUtmParams } from './utils/utmBootstrap';

export default function CompanyLayout() {
	const dispatch = useDispatch();
	const { search } = useLocation();

	useLayoutEffect(() => {
		const params = parseUtmParams(search);
		dispatchUtmParams(dispatch, ACTIONS, params);
	}, [search, dispatch]);

	return <Outlet />;
}
